import { z } from "zod";

export const LoginSchema = z.object({
  email: z
    .string()
    .email("El correo electrónico no es válido")
    .max(255, "El correo electrónico es demasiado largo"),
  password: z
    .string()
    .min(1, "La contraseña es requerida")
    .max(100, "La contraseña es demasiado larga"),
});

export type LoginFormData = z.infer<typeof LoginSchema>;
